import { render, staticRenderFns } from "./ViewTransactionComponent.vue?vue&type=template&id=18556376"
import script from "./ViewTransactionComponent.vue?vue&type=script&lang=js"
export * from "./ViewTransactionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports